import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { getUserDisplayName } from "../../helper/common";
import { PageHeader } from "../design";
import styles from "./TenantGreeting.module.css";

const TenantGreeting = ({
  user,
  isGuarantor = false,
  isCompanyTenant = false,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const name = getUserDisplayName(user, "").split(" ")[0] || user?.fname || "";

  // Company login tenants: company name from Didit KYB.
  if (isCompanyTenant) {
    const companyName =
      user?.onfido_user_kyc?.kyb_data?.company_name ||
      user?.company_legal_name ||
      "";
    return (
      <PageHeader
        className={styles.wrap}
        title={_t(
          "companyNameSkorProfile",
          `Company profile page title: "<company name>'s Skor profile"`,
          undefined,
          { name: companyName }
        )}
        description={_t(
          "companyProfileSubtitle",
          "Company profile page subtitle: this is what landlords see when you share your company profile"
        )}
      />
    );
  }

  if (isGuarantor) {
    const fullName = getUserDisplayName(user, "") || user?.fname || "";
    return (
      <PageHeader
        className={styles.wrap}
        onBack={() => navigate("/home")}
        backLabel={_t("backToMyProfile", "Back to my profile")}
        title={fullName}
        description={
          <>
            {_t("guarantor", "Guarantor")}
            <span aria-hidden="true" className={styles.dot}>
              ·
            </span>
            {_t("viewOnly", "View only")}
          </>
        }
      />
    );
  }

  return (
    <PageHeader
      className={styles.wrap}
      title={_t(
        "hiNameHeresYourSkorProfile",
        `Hi ${name}, here's your Skor profile`,
        undefined,
        { name }
      )}
    />
  );
};

export default TenantGreeting;
